import {gql} from 'apollo-boost';

export const GET_STUDENTSCORE = gql`
  query getStudentScore($id : ID!){
    getStudentScore (
      id: $id
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }

    }
  }
`;

export const GET_STUDENTSCORES_BY_FILTER = gql`

  query getStudentScoresByFilter($studentScoreFilterInput: StudentScoreFilterInput){
    getStudentScoresByFilter (
      studentScoreFilterInput:$studentScoreFilterInput
    ){
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode remark
      studentEnrollDetail {
        id
        courseOutlineRegistration {
          id
          courseOutline {
            id
          }
        }
      }
      subject{ id code nameLocal nameEng }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }
      }
    }
  }
`;

export const GET_STUDENTSCORES_FOR_TEACHER = gql`

  query getStudentScoresForTeacher($studentScoreFilterInput: StudentScoreFilterInput){
    getStudentScoresForTeacher (
      studentScoreFilterInput:$studentScoreFilterInput
    ){
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode remark
      studentEnrollDetail {
        id
        courseOutlineRegistration {
          id
          courseOutline {
            id
          }
        }
      }
      subject{ id code nameLocal nameEng }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }
      }
    }
  }
`;

export const GET_STUDENTSCORES = gql`
  query getStudentScores {
    getStudentScores {

      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }
`;

export const ADD_STUDENTSCORE = gql`
  mutation addStudentScore(
    $classSectionId: ID!
    $studentScoreInput: StudentScoreInput!
  ) {
    addStudentScore(
      classSectionId: $classSectionId
      studentScoreInput: $studentScoreInput
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }
`;

export const UPDATE_STUDENTSCORE = gql`
  mutation updateStudentScore(
    $id: ID!,
    $studentScoreInput: StudentScoreInput!
    $studentScoreDetailsInput: [StudentScoreDetailsInput]
  ) {
    updateStudentScore(
      id: $id
      studentScoreInput: $studentScoreInput
      studentScoreDetailsInput: $studentScoreDetailsInput
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode remark
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }
`;

export const UPDATE_STUDENTSCORE_ARRAY = gql`

  mutation updateStudentScoreArray(
    $studentScoreArrayInput: [StudentScoreArrayInput]
  ) {
    updateStudentScoreArray(
        studentScoreArrayInput: $studentScoreArrayInput
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode remark
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }
`;

export const DELETE_STUDENTSCORE = gql`
  mutation deleteStudentScore($id: ID!) {
    deleteStudentScore(
      id: $id
    ) {
      id studentCode teacherCode sectionNo fullScore totalScore subjectCode
      studentEnrollDetail {
        id
      }
      subject{ id code nameLocal nameEng }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacher {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      classSection {
        id sectionNo
      }
      studentScoreDetails{
        id assessmentSeq fullScore score
        classSection {
          id sectionNo
        }
        assessment {
          id nameLocal nameEng
        }

      }
    }
  }
`;

